import { cmsAxiosInstance } from '../configuration/axiosConfig';

import { ClientResponse } from '../model/ClientResponse';
import { Kontakt } from '../model/Kontakt';

const mapToKontakt = (responseItem): Kontakt => (
  {
    id: responseItem['@id'],
    path: responseItem['@path'],
    text: responseItem.text,
    nadpis: responseItem.nadpis,
  }
);

export const getKontaktSekcie = async ():
  Promise<ClientResponse<Array<Kontakt>>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/kontakt',
  );

  const sekcieKontakt = data.results.map(responseItem => mapToKontakt(responseItem));
  const requiredPaths = ['/kontakt/sekcia1/0', '/kontakt/sekcia2/0', '/kontakt/sekcia3/0', '/kontakt/sekcia4/0'];

  requiredPaths.forEach((path) => {
    const existingSekcia = sekcieKontakt.find(item => item.path === path);
    if (!existingSekcia) {
      sekcieKontakt.push({
        id: path,
        path,
        text: '',
        nadpis: '',
      });
    }
  });

  sekcieKontakt.sort((a, b) => a.path.localeCompare(b.path));

  return {
    data: sekcieKontakt,
    responseCode: status,
  };
};
